/**
 * analytics-guard.js
 * Prevents phantom analytics events during Speculation Rules pre-rendering.
 * Wraps GA4, Meta Pixel, GTM dataLayer, TikTok, and Shopify analytics.
 */
(function () {
  'use strict';

  function whenVisible(fn, name) {
    if (!document.prerendering) {
      fn();
      return;
    }
    document.addEventListener('prerenderingchange', function () {
      fn();
    }, { once: true });
  }

  function fireGA4() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'page_view', {
        page_path: window.location.pathname,
        page_title: document.title,
        navigation_type: document.prerendering === false ? 'prerender_activation' : 'standard'
      });
    }
  }

  function fireMetaPixel() {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'PageView');
    }
  }

  function fireGTM() {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        event: 'pageview_safe',
        page_path: location.pathname,
        page_title: document.title,
        is_prerender_activation: !document.prerendering
      });
    }
  }

  function fireTikTok() {
    if (typeof ttq !== 'undefined' && typeof ttq.page === 'function') {
      ttq.page();
    }
  }

  function patchShopifyAnalytics() {
    if (!window.ShopifyAnalytics || typeof window.ShopifyAnalytics.trackPage !== 'function') return;
    var original = window.ShopifyAnalytics.trackPage.bind(window.ShopifyAnalytics);
    window.ShopifyAnalytics.trackPage = function () {
      var args = arguments;
      whenVisible(function () { original.apply(null, args); }, 'ShopifyAnalytics');
    };
  }

  try { whenVisible(fireGA4, 'GA4'); } catch (e) {}
  try { whenVisible(fireMetaPixel, 'MetaPixel'); } catch (e) {}
  try { whenVisible(fireGTM, 'GTM'); } catch (e) {}
  try { whenVisible(fireTikTok, 'TikTok'); } catch (e) {}
  try { patchShopifyAnalytics(); } catch (e) {}

}());
